import { SessionProvider, useSession } from 'next-auth/react'

import UserTrack from '../UserTrack'

import CustomTrack from '@/components/integrated/CustomTrack'
import TrackEventManager from '@/components/TrackEventManager'
import { anonymousSignIn } from '@/contexts/AuthContext/hooks/anonymousSignIn'


import { useConfig } from '@/contexts/SiteContext/hooks';
import { useRouter, useUrl } from '@/hooks/routes';
import { useState, useEffect } from 'react';
export default function AppSessionProvider({
  children,
}: {
  children: React.ReactNode
}) {
  const config = useConfig()
  if (!config.sessionProviderEnabled) {
    return <>{children}</>
  }
  return (
    <SessionProvider
      refetchOnWindowFocus={false}
      refetchWhenOffline={false}
      refetchInterval={0}
    >
      {children}
      <CustomTrack />
      <TrackEventManager />
      <UserTrack />
      <AutoSignIn />
    </SessionProvider>
  )
}

function AutoSignIn() {
  const router = useRouter()
  const { status, data } = useSession()
  const [loginStatus, setLoginStatus] = useState<number[]>([])
  const [retry, setRetry] = useState(0)

  useEffect(() => {
    if (status === 'authenticated') {
      const t = data?.user?.email ? 2 : 1
      setLoginStatus((s) => (s[0] === t ? s : [t, ...s]))
    } else if (status === 'unauthenticated') {
      setLoginStatus((s) => (s[0] === 0 || s[0] === undefined ? s : [0, ...s]))
    }
  }, [status, data])

  const asPath = router.asPath
  const isApp = asPath && asPath.includes('/app')
  const url = useUrl()
  useEffect(() => {
    // 这个站点退出登录去的是首页，所以判断首页清空登录状态
    if ((asPath && asPath.includes('sign-')) || url.pathname === '/') {
      setLoginStatus((s) => (s.length > 1 ? [] : s))
    }
  }, [asPath, url.pathname])

  useEffect(() => {
    if (status !== 'unauthenticated') {
      return
    }

    if (isApp) {
      return
    }

    const [cur, prev] = loginStatus

    if (cur && cur >= 1) {
      return
    }
    if (prev && prev >= 1) {
      return
    }
    anonymousSignIn().then((res) => {
      if (!res?.ok && retry < 3) {
        setRetry(retry + 1)
      }
    })
  }, [loginStatus, retry, isApp, status])

  return null
}
